export default __webpack_public_path__ + "static/media/1Medium.4549beaf.JPG";